<div class="value-text align-center">Get 360&deg; preventive healthcare,</div>
<div class="second-heading">365 days a year</div>
